/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Box } from '@mui/material';

/* Shared */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

export const DeviceWarning: React.FC = () => {
    const { t } = useTranslation();
    const { partnerId } = useParams();

    return (
        <Link
            to={`/partner/${partnerId}/integrations/partnerLevel`}
            data-testid="partnerClientsDeviceRowCompleteSetup"
            data-trackid="partnerClientsDeviceRowCompleteSetup"
        >
            <DarkTooltip
                arrow
                placement="right"
                title={t('Tooltips.zeroDevicesTenantWarning')}
            >
                <Box sx={{ lineHeight: 0 }}>
                    <IconWithVariant
                        data-testid="warningIconNoDevices"
                        variant="warningDark"
                        src="WarningTriangleFilled"
                        size={FontSizes[2]}
                        wrapperProps={{ marginLeft: '4px' }}
                    />
                </Box>
            </DarkTooltip>
        </Link>
    );
};
